<template>
    <b-container fluid class="mt-2">
        <b-row>
            <b-col md="4">
                <b-card class="billing-card">
                    <template #header>
                        <div
                            class="
                                d-flex
                                justify-content-between
                                align-items-center
                                w-100
                                flex-md-row flex-column
                            "
                        >
                            <div><b>BILLING DETAILS</b></div>
                            <div>
                                <img class="mb-1 payment-icon" src="/static/common/images/visa.png" alt="" />
                                <img class="mb-1 payment-icon" src="/static/common/images/amex.png" alt="" />
                                <img class="mb-1 payment-icon" src="/static/common/images/mastercard.png" alt="" />
                                <img class="mb-1 payment-icon" src="/static/common/images/discover.png" alt="" />
                                <img class="mb-1 payment-icon" src="/static/common/images/dinersclub.png" alt="" />
                            </div>
                        </div>
                    </template>
                    <div v-if="billingData">
                        <b-card-text class="d-flex justify-content-between">
                            <span><b>CARD TYPE:</b></span>
                            <span>{{ billingData.type }}</span>
                        </b-card-text>
                        <b-card-text class="d-flex justify-content-between">
                            <span><b>EXPIRATION DATE:</b></span>
                            <span>{{ billingData.exp_month }}/{{ billingData.exp_year }}</span>
                        </b-card-text>
                        <b-card-text class="d-flex justify-content-between">
                            <span><b>CARD NO:</b></span>
                            <span>{{ billingData.no }}</span>
                        </b-card-text>
                        <b-card-text class="d-flex justify-content-between">
                            <span><b>CARD CVC:</b></span>
                            <span>{{ billingData.cvv2 }}</span> </b-card-text
                        ><b-card-text class="d-flex justify-content-between">
                            <span><b>CARD HOLDER:</b></span>
                            <span>{{ billingData.holder }}</span>
                        </b-card-text>
                    </div>
                    <div v-else>No Billing Data</div>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import api from '../../../../api';
    import { ADMIN_SUBSCRIBER_BILLING_DATA } from '../../../../endpoints';
    import { formatResponseError } from '../../../../utils/api';
    export default {
        data() {
            return {
                billingData: null,
            };
        },
        inject: ['userId'],
        mounted() {
            this.fetchBillingData();
        },
        methods: {
            async fetchBillingData() {
                try {
                    this.$parent.$emit('busy', true);
                    const { data } = await api.get(ADMIN_SUBSCRIBER_BILLING_DATA(this.userId));
                    this.billingData = data;
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    if (generic) {
                        this.errorToast({ text: generic });
                    } else {
                        this.errorToast({ text: 'Could not fetch billing data' });
                    }
                } finally {
                    this.$parent.$emit('busy', false);
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .payment-icon {
        width: 45px;
        height: 45px;
        object-fit: contain;
    }
    :deep(.billing-card) {
        .card-header {
            color: #333;
            background-color: #f5f5f5 !important;
            border-bottom: 1px solid #ddd !important;
            padding: 0.5rem !important;
        }
        .card-body {
            padding: 0.5rem !important;
        }
    }
</style>
